import { combineEpics } from 'redux-observable';
import notificationsEpicsRoot from './notifications';

export const notificationsEpic = combineEpics(notificationsEpicsRoot);
